export default [
	{
		modulo: 31,
		privilegio: 330,
		routerName: 'despacho-comercial',
		routerPath: '/despacho-comercial',
		componentName: 'DespachoComercial',
		componentPath: 'modules/layout/despacho-comercial/main',
	}
]
